import { React, useContext, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Spring, animated } from 'react-spring/renderprops.cjs';
import { ModalContext } from './Modal';

import { styles } from './Panel.scss';

const cx = classNames.bind(styles);

export const Panel = ({
  isAnimEnter,
  type,
  children,
  className,
  ...restProps
}) => {
  const classes = cx(
    'c-auth-panel',
    {
      [`c-auth-panel--${type}`]: type,
    },
    className,
  );

  const { direction } = useContext(ModalContext);

  const animFrom =
    direction === 'next' && type === 'primary'
      ? { opacity: 0, transform: 'translateX(100%)' }
      : { opacity: 0, transform: 'translateX(-100%)' };

  return (
    <div className={classes} {...restProps}>
      <Spring
        native
        from={isAnimEnter && animFrom}
        to={{ opacity: 1, transform: 'translateY(0)' }}>
        {props => (
          <animated.div style={props} className="c-auth-panel__inner">
            {children}
          </animated.div>
        )}
      </Spring>
    </div>
  );
};

Panel.propTypes = {
  isAnimEnter: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'primary']),
  children: PropTypes.any,
  className: PropTypes.string,
};

Panel.defaultProps = {
  isAnimEnter: true,
  type: 'default',
  className: '',
};
